// extracted by mini-css-extract-plugin
module.exports = {"mj_404_container":"index_mj_404_container__DWLKc","mj_404_bgc":"index_mj_404_bgc__oI0IK","mj_404_pic":"index_mj_404_pic__vpv7b"};